import React from "react";

import { Track } from "./Track";
import { PositionAxis } from "./PositionAxis";


export const PositionAxisTrack: React.FC = () => (
  <Track>
    <PositionAxis />
  </Track>
);
